import BaseCard from "./BaseCard";
import Variation from "./Variation";
import { formatNumber } from "../utils/utils";
import useLocale from "../hooks/useLocale";

export default function CardWithIcon({ item, productCode, type }) {
    const locale = useLocale();

    return (
        <BaseCard classNames={`cot-card-with-icon ${
            productCode == 'CAUCIONES' ? 'cauciones' : ''
        }`}>
            {item.logo ? <img src={item.logo} alt={item.descripcion} width="32px" height="32px" /> : <i />}

            <div className="labels" style={{ justifyContent: "center" }}>
                <p className="medium-text">{item.simbolo}</p>
                {item.descripcion && <p className="small-text">{item.descripcion}</p>}
            </div>

            <div className="values">
                {
                    productCode !== "FONDOS" && type !== "per" &&
                    <div className="price">
                        <p className="medium-text">{item.moneda}</p>
                        <p className="medium-text">{item.precioUltimo && (item.precioUltimo).toLocaleString("es-AR")}</p>
                    </div>
                }

                {
                    type == "per" &&
                    <div className="price">
                        <p className="medium-text"></p>
                        <p className="medium-text">{item.precioUltimo && formatNumber(item.precioUltimo, locale, 2)}%</p>
                    </div>
                }

                {
                    item.tipo &&
                    <div className="pill">
                        <p>{item.tipo}</p>
                    </div>
                }

                <Variation
                    variation={item.variacion > 0 ? "up" : item.variacion < 0 ? "down" : "none"}
                    value={item.variacion}
                />
            </div>
        </BaseCard>
    );
}
